module.exports = __webpack_public_path__ + "img/vegacheckout.78965978.png";